import de_clinius from './de-clinius';
import en_clinius from './en-clinius';
import de_clinius_ch from './de-clinius_ch';
import en_clinius_ch from './en-clinius_ch';
import deDate from './de-date';
import enDate from './en-date';
export default {
  messages: {
    clinius: {
      de: de_clinius,
      en: en_clinius
    },
    clinius_ch: {
      de: de_clinius_ch,
      en: en_clinius_ch
    },
  },
  dateTimeFormats: {
    de: deDate,
    en: enDate
  }
};
